import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/notice/list',
  owner: '/home',
  authority: 'notice_list',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};